// src/store/dashboardV2Slice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import apiServices from '../../services/apiServices';
 

// Async thunk to fetch dashboard data
export const fetchDashboardV2 = createAsyncThunk(
  'dashboardV2/fetchDashboard',
  async (range = 'month', { rejectWithValue }) => {
    try {
      const { data } = await apiServices.get(`dashboard/overview?range=${range}`);
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

const dashboardV2Slice = createSlice({
  name: 'dashboardV2',
  initialState: {
    loading: false,
    error: null,
    range: 'month',
    overview: {},
  },
  reducers: {
    setRange(state, action) {
      state.range = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDashboardV2.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDashboardV2.fulfilled, (state, action) => {
        state.loading = false;
        state.overview = action.payload;
      })
      .addCase(fetchDashboardV2.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setRange } = dashboardV2Slice.actions;
export default dashboardV2Slice.reducer;
